import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { FoodModel } from '../../models/models';
import { ConfigurationProvider, FoodProvider } from '../../providers/providers';

@Component({
  selector: 'page-food-edit',
  templateUrl: 'food-edit.html',
})
export class FoodEditPage {
  item: FoodModel;

  constructor(
    private config: ConfigurationProvider,
    private foodProvider: FoodProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.Name : null
    });
  }

  ionViewWillLoad() {
    this.item = this.params.get('item');
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // save food item
      this.foodProvider.Save(this.item).then((res: FoodModel) => {

        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res); 
      });
    }
  }

  formIsValid() {
    if (!this.item.Name) {
      this.config.showAlert('Error', 'Must enter a Name.');
      return false;
    }

    // check if item exists
    if (this.foodProvider.Exists(this.item)) {
      this.config.showAlert('Error', 'Food with this name and brand already exists!');
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/food-edit.ts